export const colors = []

export const setTheme = themeName => {
  document.body.classList.remove("theme-light")
  document.body.classList.remove("theme-dark")
  document.body.classList.add(themeName)
  localStorage.setItem("theme", themeName)
}
